export class QuoteNotes {
    id: string = '';
    quote_id: string = '';
    notes: string = '';
    type: number;       
    is_important: number = 0;       
}
